import React from 'react';
import InstructionsDialog from '../../../InstructionsDialog';
import Cookies from 'js-cookie';
import { DOMAIN } from '../../shared/utils';
import { PuzzleNames } from '../../../../utils/types';
import { PathwordStore } from '../PathwordStore';
import InstructionsVideo_mp4 from 'url:./videos/Pathword.mp4';
import InstructionsVideo_webm from 'url:./videos/Pathword.webm';
import { isMobile } from 'react-device-detect';

const closeInstructions = () => {
  PathwordStore.update(s => {
    s.instructionsAreOpen = false;
    s.isSoftPaused = false;
  });

  Cookies.set(`${PuzzleNames.Pathword}InstructionsDismissed`, 'true', {
    domain: DOMAIN,
    expires: 365,
  });
};

const Instructions = () => {
  const isOpen = PathwordStore.useState(s => s.instructionsAreOpen);

  return (
    <InstructionsDialog isOpen={isOpen} onClose={closeInstructions} className="twoColumnInstructions">
      <h1 className="instructionsTitle">How to Play the Pathword</h1>
      <div className="instructionsBody twoColumnInstructionsBody">
        <div className="writtenInstructions">
          <p>
            Start at the starred square and {isMobile ? 'tap' : 'click'} the grid squares to plot a path for the letters through the grid.
          </p>
          <br/>
          <p>
            Each step of the path will use one letter from the cluetext above the grid, in order.
          </p>

          <br/>

          <ul>
            <li>Each horizontal row must spell a 4-letter word. Columns do <span className="boldText">not</span> need to spell words.</li>
            <li>Consonants can only go in white squares. Vowels can only go in grey squares. <br/> (Y counts as a vowel.)</li>
            <li>Valid moves for the next letter are shown with each new step of the path.</li>
            <li>Blue hint letters can only be placed in their assigned spots.</li>
          </ul>
        </div>
        <div className="videoInstructions">
          <video controls autoPlay>
            <source src={InstructionsVideo_webm} type="video/webm" />
            <source src={InstructionsVideo_mp4} type="video/mp4" />
            <p>Your browser does not support HTML5 video elements.</p>
          </video>
        </div>
      </div>
    </InstructionsDialog>
  );
};

export default Instructions;